import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import HeaderCart from '../../../components/HeaderCart';
import { useNavigate } from 'react-router-dom';
import { notifyInfo } from '../../../utils/Notify';
import BackButton from '../../../components/button/BackButton';
import PrimaryButton from '../../../components/button/PrimaryButton';
import arrow from '../../../styles/img/arrow/arrow-.svg';
import { WALLET } from '../../../constants/routes';

const AddPaymentScreen = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [cbChecked, setCbChecked] = useState(false);
  const [edenredChecked, setEdenredChecked] = useState(false);
  const edenred_url = process.env.REACT_APP_EDENRED_URL;
  const redirect_uri = process.env.REACT_APP_EDENRED_REDIRECT_URI;
  const edenred_clientId = process.env.REACT_APP_EDENRED_AUTH_CLIENT_ID;
  
  const url = `${edenred_url}/connect/authorize?response_type=code&client_id=${edenred_clientId}&scope=openid%20edg-xp-mealdelivery-api%20offline_access&redirect_uri=${redirect_uri}&state=abc123&nonce=456azerty&acr_values=tenant%3Afr-ctrtku&ui_locales=fr`;
  const open = () => {
    window.open(url, '_blank');
  };
  const next = () => {
    switch (paymentMethod) {
      case 'edenred':
        !user.edendred || !user.edenred?.balance
          ? open()
          : notifyInfo('Limite de carte edenred atteinte');
        break;
      case 'cb':
        !user.creditCard[0] || !user.creditCard[0].pm
          ? navigate('./addCb')
          : notifyInfo('Limite de carte enregistrée atteinte');
        break;
      case 'conecs':
        alert('not defined yet');
        break;
      default:
        notifyInfo("Oups tu n'as pas choisi de moyen de paiment");
    }
  };

  const handleCheckboxChange = (paymentMethodToggle) => {
    paymentMethod === paymentMethodToggle
      ? setPaymentMethod('')
      : setPaymentMethod(paymentMethodToggle);
    // const newCheckedState = !isChecked;
    switch (paymentMethodToggle) {
      case 'cb':
        setCbChecked(!cbChecked);
        setEdenredChecked(false);
        break;
      case 'edenred':
        setEdenredChecked(!edenredChecked);
        setCbChecked(false);
        break;
      case 'conecs':
        break;
      default:
        break;
    }
  };
  return (
    <div className="w-full h-full justify-between overflow-y-scroll gap-4 p-8 flex flex-col ">
      <div>
        {' '}
        <div className="w-full flex flex-col gap-4">
          <BackButton onClick={() => navigate(WALLET)} />
          <HeaderCart titre="Moyens de paiement" />

          <div
            onClick={() => handleCheckboxChange('cb')}
            className="w-full flex mt-[2rem] justify-between items-center border-solid rounded-[0.6em] geomanistBold border-[1px] border-[#9C9C9C] h-[60px] p-6 text-[1.6rem] "
          >
            <div className="flex gap-4">
              <input
                type="checkbox"
                id="choicecb"
                className="absolute"
                checked={cbChecked}
                disabled={true}
              />
              <label className="cbchecklabel" htmlFor="choicecb"></label>
              Carte bancaire
            </div>
            <div className="cbimg flex no-wrap">
              <img
                className="h-10 rounded-[5px]"
                src="https://firebasestorage.googleapis.com/v0/b/gensheet-b606a.appspot.com/o/Amex.png?alt=media&token=ddb2a999-aaf8-47a0-91e6-7346a0242214"
              />
              <img
                className="h-10"
                src="https://firebasestorage.googleapis.com/v0/b/gensheet-b606a.appspot.com/o/Visa.png?alt=media&token=56967d89-2fc1-490e-94a4-631810baca52"
              />
              <img
                className="h-10"
                src="https://firebasestorage.googleapis.com/v0/b/gensheet-b606a.appspot.com/o/Mastercard.png?alt=media&token=4448318a-223e-4511-aa96-410b5da62144"
              />
            </div>
          </div>

          {/* <div
                className="w-full flex justify-between items-center border-solid rounded-[0.6em] geomanistBold border-[1px] border-[#9C9C9C] h-[60px] p-6 text-[1.6rem]"
                // onClick={() => {!user.edendred && !user.edenred.balance ? open() : notifyInfo('Limite de carte edenred atteinte')}}
              >
              <div className='flex gap-4'>
                <input
                  type="checkbox"
                  id="edenredcheck"
                  className='absolute'
                  checked={edenredChecked}
                  onChange={() => {
                    handleCheckboxChange('edenred');
                  }}
                  />
                <label htmlFor="edenredcheck" className="edenredlabel"></label>
                Edenred
              </div>
                <div className="flex text-m items-center text-[16px]" style={{fontFamily: 'Open Sans'}}> <img
                  className="h-14 px-2"
                  src="https://firebasestorage.googleapis.com/v0/b/pikkopay.appspot.com/o/Webapp%2Fcart%2FEdenred-Logo.png?alt=media&token=48042cb0-3bea-4bb5-948d-4e629a1ae046"
                />
                </div>
              </div> */}
        </div>
      </div>

      <PrimaryButton onClick={next} label="Continuer" icon={arrow} />
    </div>
  );
};

export default AddPaymentScreen;
